import { ReactNode } from "react";
import * as styles from "./FieldError.css";

interface FieldErrorProps {
  error?: string | boolean;
  children: ReactNode;
}

/**
 * Wrapper component that will display an error message below the children components.
 * A boolean `error` only marks the control invalid — it renders no message row,
 * so the layout doesn't shift.
 */
export function FieldError({ error, children }: FieldErrorProps) {
  const message = typeof error === "string" && error ? error : undefined;
  return (
    <div className={message ? styles.fieldWrapper : styles.unwrapped}>
      {children}
      {message && <div className={styles.helperText}>{message}</div>}
    </div>
  );
}
